import { axiosCustom } from 'common/common.function';
import { DetailJobExcelInput, JobDetailSearchExcelInput } from '../interfaces/admin.interface';
import { ValidateOAuthResultInput, ValidateOAuthResultOutput } from 'components/form/interfaces/member.interface';

/**
 * @Post
 * @url ${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/detail-search/excel-download
 * @returns - 200 { success: true, result: Blob }
 * @returns - 403 { success: false, message: '다운로드 실패' }
 * @description - 어드민 상세 조회 엑셀 다운로드 함수
 */
export async function jobDetailSearchExcelMutation({
  startDate,
  endDate,
  solType,
  searchType,
  searchValue,
  downloadReason,
  password,
  isIntegrated,
}: JobDetailSearchExcelInput): Promise<Blob> {
  const jwt = localStorage.getItem('jwt');
  const response = await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/detail-search/excel-download`,
    {},
    {
      headers: {
        jwt: jwt,
        'sol-type': isIntegrated ? 'ADMIN' : solType.toUpperCase(),
      },
      params: {
        startDate,
        endDate: endDate + ' 23:59:59',
        solType,
        searchType,
        searchValue,
        downloadReason,
        password,
      },
      responseType: 'blob',
    },
  );
  return response;
}

/**
 * @Post
 * @url ${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/detail-job/excel-download
 * @returns - 200 { success: true, result: Blob }
 * @returns - 403 { success: false, message: '다운로드 실패' }
 * @description 어드민 - 상세 조회 - 작업상세결과 다운로드 함수
 */
export async function detailJobExcelMutation({
  startDate,
  endDate,
  solType,
  searchType,
  searchValue,
  downloadReason,
  password,
  isIntegrated,
}: DetailJobExcelInput): Promise<Blob> {
  const jwt = localStorage.getItem('jwt');
  const response = await axiosCustom.post(
    `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/admin/detail-job/excel-download`,
    {},
    {
      headers: {
        jwt: jwt,
        'sol-type': isIntegrated ? 'ADMIN' : solType.toUpperCase(),
      },
      params: {
        startDate,
        endDate: endDate + ' 23:59:59',
        solType,
        searchType,
        searchValue,
        downloadReason,
        password,
      },
      responseType: 'blob',
    },
  );
  return response;
}

/**
 * @alias OAuth 결과 검증
 */
export const validateOAuthResult = async (body: ValidateOAuthResultInput): Promise<ValidateOAuthResultOutput> => {
  const response = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/st11/validate-oauth-result`, body);

  console.log('response', response);

  return response;
};
